import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { all } from "redux-saga/effects";
import { routerReducer } from "react-router-redux";
import { spawn, put, call } from "redux-saga/effects";


import * as searchBarComponentRedux from "../components/SearchBar/redux";
import * as treeSelectComponentRedux from "../components/TreeSelect/redux";
import * as smartTableComponentRedux from "../components/SmartTable/redux";
import * as menuRedux from "../components/Menu/redux";
import * as setupRedux from "./setupRedux";
import * as loginRedux from "../ui/Login/redux";
import * as signupRedux from "../ui/SignUp/redux";
import * as headerRedux from "../components/Header/redux";
import * as homeRedux from "../ui/Home/redux";
import * as importRedux from "../ui/Import/redux";
import * as importOverviewRedux from "../ui/ImportOverview/redux";
import * as importStatusRedux from "../ui/ImportOverview/ImportStatus/redux";
import * as importStatusOverviewRedux from "../ui/ImportOverview/ImportStatus/ImportStatusOverview/redux";
import * as importStatusTagsRedux from "../ui/ImportOverview/ImportStatus/ImportStatusTags/redux";
import * as masterRulesRedux from "../ui/MasterRules/redux";
import * as opsRedux from "../ui/Operations/redux";
import * as summaryRedux from "../ui/Summary/redux";
import * as rulesRedux from "../ui/Rules/Rules/redux";
import * as rulesreportsRedux from "../ui/Rules/Reports/redux";
import * as evidenceChartRedux from "../ui/Evidence/redux";
import * as liveRedux from "../ui/Live/redux";
import { livefeedRedux } from "../services/Live";
import * as sitetreeRedux from "../services/SiteTree/redux";
import * as seriesColorRedux from "../services/SeriesColor/redux";
import * as tariffsRedux from "../components/Tariffs/redux";

import * as timeRedux from "../redux/timeRedux";

//report components
import * as percentageoutsiderangechartRedux from "../components/ReportComponents/Charts/PercentageOutsideRangeChart/redux";
import * as linechartRedux from "../components/ReportComponents/Charts/LineChart/redux";
import * as scatterchartRedux from "../components/ReportComponents/Charts/ScatterChart/redux";
import * as barchartRedux from "../components/ReportComponents/Charts/BarChart/redux";
import * as columnchartRedux from "../components/ReportComponents/Charts/ColumnChart/redux";
import * as validationrulechartRedux from "../components/ReportComponents/Charts/ValidationRuleChart/redux";
import * as validationruleoutsideoffsetchartRedux from "../components/ReportComponents/Charts/ValidationRuleOutsideOffsetChart/redux";
import * as occurrencestableRedux from "../components/ReportComponents/Tables/OccurrencesTable/redux";
import * as historytableRedux from "../components/ReportComponents/Tables/HistoryTable/redux";
import * as learnedtableRedux from "../components/ReportComponents/Tables/LearnedRuleTable/redux";
import * as hourlyfailureheatmapRedux from "../components/ReportComponents/HeatMaps/HourlyFailureHeatMap/redux";
import * as weeklyfailureheatmapRedux from "../components/ReportComponents/HeatMaps/DailyFailureHeatMap/redux";
import * as samplesummarytableRedux from "../components/ReportComponents/Tables/SampleSummaryTable/redux";
import * as diagnostictableRedux from "../components/ReportComponents/Tables/DiagnosticOutput/redux";
import * as timeoutsiderangechartRedux from "../components/ReportComponents/Charts/TimeOutsideRangeChart/redux";
import * as dailyfailurechartRedux from "../components/ReportComponents/Charts/DailyFailureChart/redux";
import * as ruleinstancesearchRedux from "../components/ReportComponents/RuleInstanceSearch/redux";
import * as reportlivelinechartRedux from "../components/ReportComponents/Charts/ReportLiveLineChart/redux";
import * as chartwithsyncedzoomRedux from "../components/ReportComponents/Charts/ChartWithSyncedZoom/redux";
import * as charttooltipRedux from "../components/ReportComponents/Charts/ChartTooltip/redux";
import * as chartcommentRedux from "../components/ChartComment/redux";

//live components
import * as metertreeRedux from "../components/LiveComponents/MeterTree/redux";
import * as costperhourchartRedux from "../components/LiveComponents/CostPerHourChart/redux";
import * as monthlycostcomparisonchartRedux from "../components/LiveComponents/MonthlyCostComparisonChart/redux";
import * as monthlyusagecomparisonchartRedux from "../components/LiveComponents/MonthlyUsageComparisonChart/redux";
import * as livelinechartRedux from "../components/LiveComponents/LiveLineChart/redux";
import * as weeklysummarytableRedux from "../components/LiveComponents/WeeklySummaryTable/redux";

import * as rtMenuDataRedux from "../components/Realtime/MenuData/redux";

//Evidence components
import * as evidenceComponentChartRedux from "../components/EvidenceComponents/Chart/redux";
import * as evidenceComponentListRedux from "../components/EvidenceComponents/List/redux";
import * as evidenceServiceRedux from "../services/Evidence/redux";
import * as evidenceReportRedux from "../ui/Evidence/Report/redux";
import * as reportChartRedux from "../components/EvidenceComponents/ReportChart/redux";

// Other Components


//any reducers returned by persist(...);
const persistedReducers = [
	sitetreeRedux.reducer,
	rulesRedux.reducer,
	rulesreportsRedux.reducer,
	homeRedux.reducer,
	opsRedux.reducer,
	summaryRedux.reducer,
	timeRedux.reducer
];


//standard, non persisted, reducers
const rootReducer = {
	header: headerRedux.reducers.reducer,
	menu: menuRedux.reducers.reducer,
	rtMenuDataRedux: rtMenuDataRedux.reducers.reducer,
	livefeed: livefeedRedux.reducers.reducer,
	evidenceChart: evidenceChartRedux.reducers.reducer,
	live: liveRedux.reducers.reducer,
	import: importRedux.reducers.reducer,
	importOverview: importOverviewRedux.reducers.reducer,
	importStatus: importStatusRedux.reducers.reducer,
	importStatusOverview: importStatusOverviewRedux.reducers.reducer,
	importStatusTags: importStatusTagsRedux.reducers.reducer,
	masterRule: masterRulesRedux.reducers.reducer,

	form: formReducer,
	login: loginRedux.reducers.reducer,
	signup: signupRedux.reducers.reducer,
   cSearch: searchBarComponentRedux.reducers.reducer,
   treeSelect: treeSelectComponentRedux.reducers.reducer,
   smartTable: smartTableComponentRedux.reducers.reducer,
	router: routerReducer,
	setup: setupRedux.reducers.reducer,
	percentageoutsiderangechart: percentageoutsiderangechartRedux.reducers.reducer,
	validationrulechart: validationrulechartRedux.reducers.reducer,
	validationruleoutsideoffsetchart: validationruleoutsideoffsetchartRedux.reducers.reducer,
	occurrencestable: occurrencestableRedux.reducers.reducer,
	historytable: historytableRedux.reducers.reducer,
	learnedtable: learnedtableRedux.reducers.reducer,
	hourlyfailureheatmap: hourlyfailureheatmapRedux.reducers.reducer,
	weeklyfailureheatmap: weeklyfailureheatmapRedux.reducers.reducer,
	samplesummarytable: samplesummarytableRedux.reducers.reducer,
	timeoutsiderangechart: timeoutsiderangechartRedux.reducers.reducer,
	dailyfailurechart: dailyfailurechartRedux.reducers.reducer,
	metertree: metertreeRedux.reducers.reducer,
	costperhourchart: costperhourchartRedux.reducers.reducer,
	tariffs: tariffsRedux.reducers.reducer,
	ruleinstancesearch: ruleinstancesearchRedux.reducers.reducer,
	monthlycostcomparisonchart: monthlycostcomparisonchartRedux.reducers.reducer,
	monthlyusagecomparisonchart: monthlyusagecomparisonchartRedux.reducers.reducer,
	livelinechart: livelinechartRedux.reducers.reducer,
	diagnosticstable: diagnostictableRedux.reducers.reducer,
   linechart: linechartRedux.reducers.reducer,
   scatterchart: scatterchartRedux.reducers.reducer,
   barchart: barchartRedux.reducers.reducer,
   columnchart: columnchartRedux.reducers.reducer,
	weeklysummarytable: weeklysummarytableRedux.reducers.reducer,
	evidenceComponentChart: evidenceComponentChartRedux.reducers.reducer,
	evidenceComponentList: evidenceComponentListRedux.reducers.reducer,
	evidenceService: evidenceServiceRedux.reducers.reducer,
	evidenceReport: evidenceReportRedux.reducers.reducer,
	reportlivelinechart: reportlivelinechartRedux.reducers.reducer,
	charttooltip: charttooltipRedux.reducers.reducer,
   reportChart: reportChartRedux.reducers.reducer,
	chartwithsyncedzoom: chartwithsyncedzoomRedux.reducers.reducer,
	chartcomment: chartcommentRedux.reducers.reducer,
	
	seriesColor: seriesColorRedux.reducers.reducer,

};


export default combineReducers(MergeReducers(rootReducer, persistedReducers));


const combineSagas = function*() {
	const sagas = [
		homeRedux.sagas.rootSaga.bind(homeRedux.sagas),
		headerRedux.sagas.rootSaga.bind(headerRedux.sagas),
		menuRedux.sagas.rootSaga.bind(menuRedux.sagas),
		rtMenuDataRedux.sagas.rootSaga.bind(rtMenuDataRedux.sagas),
		livefeedRedux.sagas.rootSaga.bind(livefeedRedux.sagas),
		treeSelectComponentRedux.sagas.rootSaga.bind(treeSelectComponentRedux.sagas),
		smartTableComponentRedux.sagas.rootSaga.bind(smartTableComponentRedux.sagas),
		setupRedux.sagas.rootSaga.bind(setupRedux.sagas),
		loginRedux.sagas.rootSaga.bind(loginRedux.sagas),
		signupRedux.sagas.rootSaga.bind(signupRedux.sagas),
		opsRedux.sagas.rootSaga.bind(opsRedux.sagas),
		timeRedux.sagas.rootSaga.bind(timeRedux.sagas),
		summaryRedux.sagas.rootSaga.bind(summaryRedux.sagas),
		importRedux.sagas.rootSaga.bind(importRedux.sagas),
		importOverviewRedux.sagas.rootSaga.bind(importOverviewRedux.sagas),
		importStatusRedux.sagas.rootSaga.bind(importStatusRedux.sagas),
		importStatusOverviewRedux.sagas.rootSaga.bind(importStatusOverviewRedux.sagas),
		importStatusTagsRedux.sagas.rootSaga.bind(importStatusTagsRedux.sagas),
		masterRulesRedux.sagas.rootSaga.bind(masterRulesRedux.sagas),
		rulesRedux.sagas.rootSaga.bind(rulesRedux.sagas),
		scatterchartRedux.sagas.rootSaga.bind(scatterchartRedux.sagas),
		diagnostictableRedux.sagas.rootSaga.bind(diagnostictableRedux.sagas),
      liveRedux.sagas.rootSaga.bind(liveRedux.sagas),
      linechartRedux.sagas.rootSaga.bind(linechartRedux.sagas),
      barchartRedux.sagas.rootSaga.bind(barchartRedux.sagas),
      columnchartRedux.sagas.rootSaga.bind(columnchartRedux.sagas),
		rulesreportsRedux.sagas.rootSaga.bind(rulesreportsRedux.sagas),
		evidenceChartRedux.sagas.rootSaga.bind(evidenceChartRedux.sagas),
		percentageoutsiderangechartRedux.sagas.rootSaga.bind(percentageoutsiderangechartRedux.sagas),
		validationrulechartRedux.sagas.rootSaga.bind(validationrulechartRedux.sagas),
		validationruleoutsideoffsetchartRedux.sagas.rootSaga.bind(validationruleoutsideoffsetchartRedux.sagas),
		historytableRedux.sagas.rootSaga.bind(historytableRedux.sagas),
		learnedtableRedux.sagas.rootSaga.bind(learnedtableRedux.sagas),
		occurrencestableRedux.sagas.rootSaga.bind(occurrencestableRedux.sagas),
		hourlyfailureheatmapRedux.sagas.rootSaga.bind(hourlyfailureheatmapRedux.sagas),
		weeklyfailureheatmapRedux.sagas.rootSaga.bind(weeklyfailureheatmapRedux.sagas),
		samplesummarytableRedux.sagas.rootSaga.bind(samplesummarytableRedux.sagas),
		timeoutsiderangechartRedux.sagas.rootSaga.bind(timeoutsiderangechartRedux.sagas),
		dailyfailurechartRedux.sagas.rootSaga.bind(dailyfailurechartRedux.sagas),
		metertreeRedux.sagas.rootSaga.bind(metertreeRedux.sagas),
		costperhourchartRedux.sagas.rootSaga.bind(costperhourchartRedux.sagas),
		sitetreeRedux.sagas.rootSaga.bind(sitetreeRedux.sagas),
		seriesColorRedux.sagas.rootSaga.bind(seriesColorRedux.sagas),
		tariffsRedux.sagas.rootSaga.bind(tariffsRedux.sagas),
		ruleinstancesearchRedux.sagas.rootSaga.bind(ruleinstancesearchRedux.sagas),
		monthlycostcomparisonchartRedux.sagas.rootSaga.bind(monthlycostcomparisonchartRedux.sagas),
		monthlyusagecomparisonchartRedux.sagas.rootSaga.bind(monthlyusagecomparisonchartRedux.sagas),
		livelinechartRedux.sagas.rootSaga.bind(livelinechartRedux.sagas),
		weeklysummarytableRedux.sagas.rootSaga.bind(weeklysummarytableRedux.sagas),
		evidenceComponentChartRedux.sagas.rootSaga.bind(evidenceComponentChartRedux.sagas),
		evidenceComponentListRedux.sagas.rootSaga.bind(evidenceComponentListRedux.sagas),
		evidenceServiceRedux.sagas.rootSaga.bind(evidenceServiceRedux.sagas),
		evidenceReportRedux.sagas.rootSaga.bind(evidenceReportRedux.sagas),
		reportlivelinechartRedux.sagas.rootSaga.bind(reportlivelinechartRedux.sagas),
		charttooltipRedux.sagas.rootSaga.bind(charttooltipRedux.sagas),
		reportChartRedux.sagas.rootSaga.bind(reportChartRedux.sagas),
		chartcommentRedux.sagas.rootSaga.bind(chartcommentRedux.sagas),
	]

	yield all(
		sagas.map(saga =>
			 spawn(function*() {
				  let isSyncError = false;
				  while (!isSyncError) {
						isSyncError = true;
						try {
							 setTimeout(() => (isSyncError = false));
							 yield call(saga);
						} catch (e) {
							 console.error("Saga Error:", e)
							 yield put({ type: "SAGA_FAILED", payload: e });
							 if (isSyncError) {
								  throw e;
							 }
						}
				  }
			 })
		)
  );
};

export const rootSaga = combineSagas;



/**
 * extract the names of props from [persisted] and put into root. this is so we dont have to type the name of props in 2 places
 */
function MergeReducers(root, persisted) {
	for (let index = 0; index < persisted.length; index++) {
		const pers = persisted[index];
		for (var prop in pers) {
			if (pers.hasOwnProperty(prop)) {
				if (root[prop]) {
					throw new Error("Reducer prop " + prop + " already exists");
				} else {
					root[prop] = pers[prop];
				}
			}
		}
	}
	return root;
}



// WEBPACK FOOTER //
// ./src/boot/reduxRoot.js